import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-pdf-viewer-admin-config',
  templateUrl: './pdf-viewer-admin-config.component.html',
  styleUrls: ['./pdf-viewer-admin-config.component.scss']
})
export class AtwPdfViewerAdminConfig extends AtwUpdateDbComponent  {
@Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  pdfUrl: any;
  data_object: any = {};
  selectedFile
  pdfTitle: string;
  id_subproject: any = "";
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhImage: VhImage,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
  }

  ngOnChanges() {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    if (isPlatformBrowser(this.platformId))
      this.getData();
  }

  getData() {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectChoosing.staticdata.src);
    this.pdfTitle = this.staticdata.src.split('/').pop().split('.pdf')[0].replace(/%20/g, ' ');
  }

  // /**
  // * Hàm update class
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }


  /**
  * Hàm này dùng để cho phép mở menu config .
  * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
  * @param: value
  */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  update(src) {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    this.data_object.nameFile = this.selectedFile.name;
    this.objectChoosing.staticdata.src = src;
    this.objectChoosing.staticdata.nameFile = this.selectedFile.name;
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
        
      this.vhEventMediator.notifyOnConfigChanged({ code: this.objectChoosing._id, status: 'update-UI', id_parent: this.objectChoosing.id_block || this.objectChoosing.id_object });
      return;
    }


    // update
    this.vhQueryAutoWeb
    .updateObject(this.objectChoosing._id, { 
      staticdata: {
        ...this.objectChoosing.staticdata,
        src: src, 
        nameFile: this.selectedFile.name
      }
     })
    .then(
      (bool) => {
        this.functionService.createMessage("success", "Thay đổi file thành công");
      },
      (error) => {

        this.functionService.createMessage("error", error);

      }
    );
  }

  onFileSelected(event) {
    // nếu là cập nhật file thì phải truyền vào oldFileURL
    // kiểm tra xem có lưu file url chưa
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.vhImage.uploadFileFromDesktop(this.selectedFile, 'file-pdf', this.data_object?.src || null, 20000000)
        .then((rsp: any) => {
          // console.log('rsp', rsp);
          if (rsp.vcode === 0) {
            this.update(rsp.data + '#view=FitH');
          } else
            this.functionService.createMessage("error", "Tải file thất bại! Lý do: " + rsp.message);
        }, error => {
          this.functionService.createMessage("error", "Tải file thất bại");
        }
        );
    }

  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
